export const financeiroTypes = {
  resumo: {
    total: '',
    totalPago: '',
  },
  detalhado: [],
}
